module.exports = {
  SocketServer: `//vvcroom-portal.viettel.vn`
  //SocketServer: `http://27.71.113.147:9010`
}